import React, { PropTypes } from 'react';
import ReactTooltip from 'react-tooltip';

export default class DeleteRect extends React.Component {

	render () {
		return (
			<div className="">			
				<button className="delete-rect-button" onClick={() => this.props.onClick()}>
					<i className="fa fa-undo" data-tip="Remover Retângulo" />
					<ReactTooltip place="bottom" />
				</button>
			</div>			
		);
	}
}

DeleteRect.propTypes = {
	onClick: PropTypes.func
};


// WEBPACK FOOTER //
// ./src/components/Explorer/DeleteRect.js